<template>
    <TimeConstraintList
            v-if="currentBox !== null"
            :constrainedItem="currentBox"
            :timeConstraintType="timeConstraintType"
    />
</template>
<script>
    import {mapState} from "vuex";
    import TimeConstraintList from "@/components/common/TimeConstraintList";
    import TimeConstraintApis from "@/apis/_apiTimeConstraints";

    export default {
        components: {TimeConstraintList},
        computed: {
            ...mapState({
                currentBox: state => state.currentBox
            })
        },
        data() {
            return {
                viewState: {
                    showNewPanel: false
                },
                timeConstraintType: TimeConstraintApis.TIME_CONSTRAINT_TYPES.BOX.value
            };
        }
    };
</script>
<style scoped>
</style>